/**
 * Public CMS content fetch for the customer web app (006 US10, Slice C).
 * Anonymous GET against /api/v1/content/{slug}; the backend serves the requested
 * language with English fallback and sets Cache-Control. Mirrors musicPreferencesService.
 */
import { getApiUrl } from '../../lib/runtimeConfig';
import { getCurrentLanguage } from '@/i18n/i18nCore';

const API_URL = getApiUrl() || 'http://localhost:5001';

export interface PublicContentEntry {
  slug: string;
  title: string;
  summary: string | null;
  bodyHtml: string | null;
}

export interface PublicContent {
  slug: string;
  type: 'document' | 'collection' | 'entry';
  languageCode: string;
  resolvedFrom: string;
  title: string;
  bodyHtml: string | null;
  summary: string | null;
  children: PublicContentEntry[] | null;
}

/** Fetches a content page/collection by slug. Returns null on 404 (unknown/hidden). */
export async function fetchContent(slug: string, lang?: string): Promise<PublicContent | null> {
  const language = lang ?? getCurrentLanguage();
  const response = await fetch(`${API_URL}/api/v1/content/${slug}?lang=${encodeURIComponent(language)}`, {
    method: 'GET',
    headers: { 'Accept-Language': language, Accept: 'application/json' },
  });

  if (response.status === 404) return null;
  if (!response.ok) throw new Error(`Failed to fetch content '${slug}': ${response.status}`);
  return response.json();
}
